import axios from 'axios'
import Cookies from 'js-cookie'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'
import { refreshTokenApi } from '@/api/login'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 15000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  return Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
  /**
  * code为非200是抛错 可结合自己业务进行修改
  */
    const res = response.data
    if (res.code !== 200) {
      if (res.code !== 401) {
        Message({
          message: res.message,
          type: 'error',
          duration: 3 * 1000
        })
      }

      // 401:未登录;
      if (res.code === 401) {
        return refreshTokenApi({
          refreshToken: Cookies.get('refreshToken')
        }).then(res => {
          if (res.code === 200) {
            let hh = `${res.data.tokenHead}${res.data.token}`
            Cookies.set('loginToken', hh)
            Cookies.set('refreshToken', res.data.refreshToken)
            // 重新设置请求头
            response.config.headers['Authorization'] = hh
            // 重新发送原请求
            return service.request(response.config)
          } else {
            // 刷新失败，提示重新登录
            MessageBox.confirm('登录已过期，请重新登录', '确定登出', {
              confirmButtonText: '重新登录',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              store.dispatch('FedLogOut').then(() => {
                location.reload()
              })
            })
            return Promise.reject('error')
          }
        }).catch(() => {
          // 刷新接口调用失败
          MessageBox.confirm('登录已过期，请重新登录', '确定登出', {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            store.dispatch('FedLogOut').then(() => {
              location.reload()
            })
          })
          return Promise.reject('error')
        })
      }
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error)// for debug
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 3 * 1000
    // })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js